import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import PortfolioSection from "./components/PortfolioSection";
import ColorHelperSection from "./components/ColorHelperSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import SeoManager from "./components/SeoManager";

export default function HomePage() {
  return (
    <div className="min-h-screen font-sans antialiased">
      <SeoManager />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <TestimonialsSection />
        <PortfolioSection />
        <ColorHelperSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
